const state = {
  allIds: [],
  byId: {}
};

const getters = {
  find: state => id => state.byId[id],
  list: (state, getters) => state.allIds.map(id => getters.find(id))
};

const actions = {
  addMedia: ({ commit }, media) => {
    media.forEach(m => {
      commit('add', m);
    });
  }
};

const mutations = {
  add: (state, media) => {
    state.byId[media.id] = media;
    if (state.allIds.includes(media.id)) return;
    state.allIds.push(media.id);
  }
};

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
};
